import { createContext } from 'react';
import { useAuthContext } from '@cognite/e2e-auth';
import { useFlag } from '@fusion/feature-flags';
import { useIsOnline } from '../../hooks/use-is-online';
import { readCdmOfflineConfiguration } from './cdm-read-offline-configuration';

export interface UseSavedCdmConfigurationContextInterface {
  useAuthContext: () => {
    authState: { user: { cdfId: string } };
    client: Pick<
      ReturnType<typeof useAuthContext>['client'],
      'getBaseUrl' | 'project'
    >;
  };
  useIsOnline: () => boolean;
  useFlag: typeof useFlag;
  readConfiguration: typeof readCdmOfflineConfiguration;
  indexedDbFactory?: IDBFactory;
}

export const UseSavedCdmConfigurationContext =
  createContext<UseSavedCdmConfigurationContextInterface>({
    useAuthContext,
    useIsOnline,
    useFlag,
    readConfiguration: readCdmOfflineConfiguration,
  });
